import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  faEnvelope,
  faPhone,
  faUpload,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Upload } from "antd";
import EditableText from "Components/EditableText";
import ShowActionButtons from "Pages/Dashboard/ShowActionButtons";
import UploadProfilePic from "Components/UploadProfilePic";
import { updateAccountDetails } from "Sdk/Actions";
import {
  getThemeColor,
  getUserDetailsFromReducer,
} from "Store/reducers/Auth/AuthSlice";
import { uploadServicesPic } from "Utility/UploadFile";
import ShowSocialMediaIcons from "./ShowSocialMediaIcons";

export const Profile = () => {
  const userDetails = useSelector(getUserDetailsFromReducer);
  const themeColor = JSON.parse(useSelector(getThemeColor));

  const UpdateProfileData = async (values) => {
    try {
      const userData = {
        ...values,
        username: userDetails?.username,
      };

      await updateAccountDetails(userData);
      // message.success("Changes saved!");
    } catch (error) {
      console.log(error);
    }
  };

  const [ProfilePicFile, setProfilePicFile] = useState(null);
  const [imagePreview, setimagePreview] = useState(null);

  const setPreviewAndUpload = async (file) => {
    setimagePreview(await getBase64(file));
    const uploadResult = await uploadServicesPic(file, userDetails?.username);
    UpdateProfileData({ logo: uploadResult?.key });
  };

  const props = {
    name: "file",
    multiple: false,
    async onChange(info) {
      setProfilePicFile(info?.fileList?.[0]?.originFileObj);
    },
    onDrop(e) {
      setProfilePicFile(e.dataTransfer.files?.[0]?.originFileObj);
    },
    beforeUpload() {
      return false;
    },
    maxCount: 1,
    accept: "image/*",
  };

  useEffect(() => {
    if (ProfilePicFile) {
      setPreviewAndUpload(ProfilePicFile);
    } else {
      setimagePreview(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ProfilePicFile]);

  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  return (
    <div className="flex flex-col items-start md:items-start sm:items-start w-full md:w-2/6 md:sticky  md:top-0 md:h-screen md:overflow-scroll h-full md:ps-8 md:py-8 sm:px-12 sm:py-10 p-5 md:pe-0">
      {/* Profile Photo */}
      <div className="mb-4">
        <Upload.Dragger
          {...props}
          className={`min-h-[184px] min-w-[184px] w-full h-full flex items-center justify-center transition duration-500 ${
            !imagePreview && "border border-radius"
          }`}
          style={{ borderColor: !imagePreview ? themeColor?.text : undefined }}
          showUploadList={false}
          colorFillAlter="red"
        >
          {userDetails?.logo || imagePreview ? (
            <UploadProfilePic
              S3Key={userDetails?.logo}
              src={imagePreview}
              alt="User Logo"
            />
          ) : (
            <p className="text-md" style={{ color: themeColor?.text }}>
              <FontAwesomeIcon icon={faUpload} />
              <br />
              Add Logo
            </p>
          )}
        </Upload.Dragger>
      </div>

      {/* Profile Information */}
      <div className="w-full text-center">
        <EditableText
          className="text-4xl font-bold w-full "
          onEditDone={UpdateProfileData}
          placeholder="Your Business Name"
          name="name"
          key="name"
        >
          {userDetails?.name}
        </EditableText>
        <EditableText
          className="text-lg  w-full "
          onEditDone={UpdateProfileData}
          name="description"
          placeholder="Your Bio..."
          key="description"
        >
          {userDetails?.description}
        </EditableText>
        <EditableText
          className="text-base w-full text-cener p-0"
          onEditDone={UpdateProfileData}
          name="phone"
          key="phone"
          placeholder="Phone Number"
          icon={<FontAwesomeIcon icon={faPhone} />}
        >
          {userDetails?.phone}
        </EditableText>
        <EditableText
          className="text-base w-full text-ceter p-0"
          onEditDone={UpdateProfileData}
          name="email"
          key="email"
          placeholder="Email"
          icon={<FontAwesomeIcon icon={faEnvelope} />}
        >
          {userDetails?.email}
        </EditableText>
      </div>

      {/* Show profile links */}
      <div className="my-4">
        <ShowSocialMediaIcons />
        <ShowActionButtons />
      </div>
    </div>
  );
};
